<div fxFlex="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <div class="av-pg-title">{{pg_title}}</div>
    <ng-content></ng-content>
</div>
